import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs'

export default class extends Controller {
    static targets = ["shelf"]

    connect() {
        this.createShelfSortable()
    }

    createShelfSortable() {
        const csrfToken = document.querySelector("[name='csrf-token']").content

        new Sortable(this.shelfTarget, {
            handle: '.sort-handle',
            animation: 150,
            easing: "cubic-bezier(1, 0, 0, 1)",
            onEnd: (evt) => {
                const productElement = evt.item
                console.log(evt.item)
                const shelfProductId = productElement.dataset.id

                const formData = new FormData()
                formData.append('shelf_product[position]', evt.newIndex)

                fetch(`/shelves/products/${shelfProductId}`, {
                    method: "PATCH",
                    headers: {
                        "X-CSRF-Token": csrfToken
                    },
                    body: formData
                })
            }
        })
    }
} 